import { render, staticRenderFns } from "./DaiEx.vue?vue&type=template&id=0d544fcd"
import script from "./DaiEx.vue?vue&type=script&lang=js"
export * from "./DaiEx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports